export default __webpack_public_path__ + "static/media/Takbir.cfe7f5e9.mp3";